module.exports = __webpack_public_path__ + "media/images/notification-template-5705c2465d3d379a3d9ccaf6040ae204.svg";